import React, { useMemo, useState } from 'react';


function OfferPopover({ offer }: any) {
    const [displayErrors, setDisplayErrors] = useState<boolean>(false);

    return (
        <div onMouseEnter={() => setDisplayErrors(true)} onMouseLeave={() => setDisplayErrors(false)} style={{ position: 'relative', height: 'fit-content' }}>
            <div
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: 8,
                    backgroundColor:
                        offer.marketplace_states[0].status === 'ERROR' ||  offer.marketplace_states[1].status === 'ERROR'
                            ? 'red'
                            : offer.marketplace_states[0].status === 'WARNING' || offer.marketplace_states[1].status === 'WARNING'
                            ? 'orange'
                            : offer.marketplace_states[0].status === 'ONLINE' && offer.marketplace_states[1].status === 'ONLINE'
                            ? '#02c102'
                            : 'grey',
                }}
            ></div>
            {displayErrors && (
                <div className='popoverOffers'>
                    <div>
                        <h3 className='titlePage' style={{ marginBottom: 10, height: 'fit-content', fontSize: 18 }}>
                            Stati marketplaces
                        </h3>
                        <div className='marketplace-status'>
                            <p className='field-label'>SKU</p>
                            <p className='field-label'>Marketplace</p>
                            <p className='field-label'>Creazione</p>
                            <p className='field-label'>Stato</p>
                            <p className='field-label'>Aggiornamento</p>
                            <p className='field-label'>Note</p>
                        </div>
                        <div className='marketplace-status'>
                            {offer.marketplace_states && offer.marketplace_states.length > 0 && (
                                <>
                                    {offer.marketplace_states.map((item: any, i: number) => {
                                        const createdDate = new Date(item.created_at);
                                        const updatedDate = new Date(item.updated_at);
                                        const formattedCreatedDate = createdDate.toLocaleDateString('it-IT', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            timeZone: 'Europe/Rome',
                                        });
                                        const formattedUpdatedDate = updatedDate.toLocaleDateString('it-IT', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            timeZone: 'Europe/Rome',
                                        });
                                        return (
                                            <>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {item.product_sku}
                                                </p>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {item.marketplace}
                                                </p>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {formattedCreatedDate}
                                                </p>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {item.status}
                                                </p>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {formattedUpdatedDate}
                                                </p>
                                                <p style={{ marginLeft: 0, width: 'fit-content' }} className='sidebar-user-info-name'>
                                                    {item.notes}
                                                </p>
                                            </>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OfferPopover;
